















































import {Component, Mixins, Vue} from 'vue-property-decorator';
declare let google: any;
import {ConvertModule} from '@/stores/modules/convert';
import {WebService} from '@/services/web.service';
import ArrowRightIcon from '../assets/arrow-right.svg';

@Component({
	components: {
		ArrowRightIcon: ArrowRightIcon
	},
	computed: {}
})
export default class Locations extends Vue {
	map: google.maps.Map;

	get locations() {
		return ConvertModule.locations;
	}

	async mounted() {
		await WebService.getLocations();
		this.map = await (this.$refs.baseMap as any).$mapPromise;
		this.fitToLocations();
	}

	fitToLocations() {
		const latLngBounds = new google.maps.LatLngBounds();
		this.locations.forEach((location) => {
			latLngBounds.extend({
				lat: location.lat,
				lng: location.lng
			});
		});
		this.map.fitBounds(latLngBounds);
	}
}
